<template>
  <div id="app">
    <WeChatBrowserGuide v-if="showWeChatGuide" :meeting-link="meetingLink" />
    <div v-else :inert="Boolean(meetingAccountNotice)" style="display: contents">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <MeetingAccountNotice />
    <Icon v-if="route.path === '/welcomePage'" name="companyInfo" class="aboutus" @click="showDraw = true"/>
    <el-drawer
      v-model="showDraw"
      direction="ltr"
      size="50%"
    >
      <aboutUs></aboutUs>
    </el-drawer>
  </div>
</template>
<script setup>
import { computed, ref } from "vue"
import { useRoute } from "vue-router"
import WeChatBrowserGuide from '@/components/WeChatBrowserGuide.vue'
import MeetingAccountNotice from '@/components/MeetingAccountNotice.vue'
import { meetingAccountNotice } from '@/utils/useMeetingAccount.js'
import { shouldShowWeChatGuide } from '@/utils/wechatBrowser.js'
const route = useRoute()
const showWeChatGuide = computed(() => shouldShowWeChatGuide(route.name))
const meetingLink = computed(() => new URL(route.fullPath, window.location.origin).href)
import aboutUs from '@/components/aboutUs.vue'
const showDraw = ref(false)
</script>
<style>
html{
  height: 100%;
  width: 100%;
}
body{
  height:100%;
  width: 100%;
  overflow: hidden;
  padding:0;
  margin:0;
  font-family: "KaiTi", "楷体", "STKaiti", "KaiTi_GB2312", "Times New Roman", serif!important;
}
#app{
  width: 100%;
  height: 100%;
}
.el-button {
  font-family: "KaiTi", "楷体", "STKaiti", "KaiTi_GB2312", "Times New Roman", serif!important;
}
.el-button--primary{
  background: rgba(84, 88, 96, 1)!important;
  border:0!important;
  border-radius: 0!important;
}
.el-button--primary:active {
  background-color: rgba(84, 88, 96, 0.8) !important;
}
.el-button--text{
  background: transparent!important;
}
/* 输入框 */
.el-input__inner,
.el-textarea__inner {
  font-family: "KaiTi", "楷体", "STKaiti", "KaiTi_GB2312", "Times New Roman", serif!important;
}
.el-button--danger.is-plain{
  background: transparent!important;
  border-color:#CC5A5A!important;
  color:#CC5A5A!important;
  font-size: 16px;
  box-shadow: none!important;
}
.el-textarea__inner, .el-input__wrapper{
  background: transparent!important;
  border:0!important;
  box-shadow: none!important;
  border-radius: 0!important;
  color:#fff!important;
  font-size:18px!important;
}
.el-button--danger.is-plain:hover,.el-button--danger.is-plain:active{
  background: rgba(204, 90, 90, 0.3)!important;
}
.el-input__wrapper,.el-select__wrapper,.el-input-group__append{
  border: 0!important;
  box-shadow: none!important;
  border-radius: 0!important;
}
.el-input__wrapper{
  padding:0!important;
  height: 42px!important;
  line-height: 42px!important;
  font-size: 16px!important;
}
.el-input__wrapper,.el-input-group__append{
  border-bottom: 1px solid #ECECED!important;
}
.el-input__wrapper.is-focus,.is-focus .el-input-group__append{
  border-bottom: 1px solid #545860!important;
  box-shadow: none!important;
}

/* 消息提示（ElMessage / ElMessageBox） */
.el-message,
.el-message-box {
  font-family: "KaiTi", "楷体", "STKaiti", "KaiTi_GB2312", "Times New Roman", serif!important;
}
.el-select__selected-item,
.el-button--text,.el-button--text:active,
.el-button--text:hover,
.el-button--text:not(.is-disabled):active,
.el-button--text:not(.is-disabled):hover{
  color:#fff!important;
  font-weight: 400!important;
}
.el-statistic__number{
  color:#fff!important;
  font-size: 56px!important;
}
/* 表格 */
.el-table,
.el-table th,
.el-table td {
  font-family: "KaiTi", "楷体", "STKaiti", "KaiTi_GB2312", "Times New Roman", serif!important;
}
.aboutus{
  position: absolute;
  z-index:999;
  left:0;
  top:0;
  font-size:24px;
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 6px;               /* 垂直滚动条宽度 */
  height: 6px;              /* 水平滚动条高度 */
  background: transparent;  /* 背景透明 */
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3); /* 滑块颜色 */
  border-radius: 3px;                   /* 圆角 */
}

::-webkit-scrollbar-track {
  background: transparent;  /* 去掉轨道背景 */
}

::-webkit-scrollbar-button {
  display: none;            /* 隐藏上下箭头 */
}

/* ===== Firefox ===== */
* {
  scrollbar-width: thin;                   /* 细滚动条 */
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent; /* 滑块颜色 + 轨道背景 */
}
</style>
